const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl && process.env.NODE_ENV === 'production') {
  console.error('REACT_APP_API_URL is not set in production!');
}

export const serverApi: string = apiUrl || 'http://localhost:3001';

export const Messages = {
  error1: "Somthing went wrong!",
  error2: "Please login first!",
  error3: "Please fulfill all inputs!",
  error4: "Message is empty!",
  error5: "Only images with jpeg, jpg, png format allowed!",
  error6: "Please QR scane first!",
};
